import React from 'react';
import { useTranslation } from 'react-i18next';

const TopProductsTable = ({ products }) => {
    const { t } = useTranslation();
    if (!products || products.length === 0) return null;

    const maxQty = Math.max(...products.map(p => parseFloat(p.total_quantity) || 0));

    return (
        <div style={cardStyle}>
            <div style={headerStyle}>
                <div>
                    <span style={titleStyle}>{t('common.analyticsWidgets.topProducts.title')}</span>
                    <div style={subtitleStyle}>{t('common.analyticsWidgets.topProducts.subtitle')}</div>
                </div>
                <span style={badgeStyle}>{products.length} {t('common.analyticsWidgets.topProducts.items')}</span>
            </div>
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                    <thead>
                        <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                            <th style={thStyle('left')}>{t('common.analyticsColumns.product')}</th>
                            <th style={thStyle('left')}>{t('common.analyticsColumns.category')}</th>
                            <th style={thStyle('right')}>{t('common.analyticsColumns.orders')}</th>
                            <th style={thStyle('right')}>{t('common.analyticsColumns.quantity')}</th>
                            <th style={thStyle('right')}>{t('common.analyticsColumns.weight')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((row, i) => {
                            const qty = parseFloat(row.total_quantity) || 0;
                            const pct = maxQty > 0 ? (qty / maxQty) * 100 : 0;
                            return (
                                <tr key={row.product_size_id || i} style={{ borderBottom: '1px solid #f9fafb' }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    <td style={{ ...tdStyle, maxWidth: 160 }}>
                                        <div style={{ fontWeight: 600, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {row.alias_name || row.product_name}
                                        </div>
                                        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 1 }}>{row.product_name}</div>
                                    </td>
                                    <td style={tdStyle}>
                                        <span style={{
                                            fontSize: 11, fontWeight: 600, color: '#1d4ed8',
                                            backgroundColor: '#eff6ff', borderRadius: 6,
                                            padding: '2px 8px', whiteSpace: 'nowrap'
                                        }}>
                                            {row.category_name}
                                        </span>
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'right', fontWeight: 700, color: '#7c3aed' }}>
                                        {row.order_count}
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'right' }}>
                                        <div style={{ fontWeight: 600, color: '#111827' }}>
                                            {Number(qty).toLocaleString('en-IN', { maximumFractionDigits: 0 })}
                                        </div>
                                        <div style={{ height: 3, borderRadius: 2, backgroundColor: '#e5e7eb', marginTop: 4, width: '100%', minWidth: 60 }}>
                                            <div style={{ height: '100%', borderRadius: 2, backgroundColor: '#7c3aed', width: `${pct}%` }} />
                                        </div>
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'right', fontWeight: 600, color: '#059669' }}>
                                        {parseFloat(row.total_weight_tons || 0).toFixed(2)} Ton
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const cardStyle = {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    border: '1px solid #f3f4f6',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    height: '100%',
};
const headerStyle = {
    padding: '18px 20px 14px',
    borderBottom: '1px solid #f3f4f6',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
};
const titleStyle = { fontSize: 15, fontWeight: 700, color: '#111827', display: 'block' };
const subtitleStyle = { fontSize: 12, color: '#9ca3af', marginTop: 2 };
const badgeStyle = {
    fontSize: 11, fontWeight: 700, color: '#7c3aed',
    backgroundColor: '#f5f3ff', borderRadius: 20, padding: '3px 10px'
};
const thStyle = (align) => ({
    padding: '10px 16px',
    textAlign: align,
    fontSize: 11,
    fontWeight: 700,
    color: '#9ca3af',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    backgroundColor: '#fafafa',
    whiteSpace: 'nowrap',
});
const tdStyle = {
    padding: '10px 16px',
    verticalAlign: 'middle',
};

export default TopProductsTable;
